import Button from "components/buttons/Button";
import RadioButtonCard from "components/radioButtonCard/RadioButtonCard";
import SearchInputWithChipCard from "components/searchInputWithChip/SearchInputWithChipCard";
import Spacer from "components/Spacer/Spacer";
import { bh_sub_steps } from "helpers/enum";
import useModal from "hooks/useModal";
import useToastify from "hooks/useToastify";
import React from "react";
import AddMedicationModal from "../../dermatology/medicalHistory/AddMedicationModal";

function Medications({
  incompleteData,
  updateVisit,
  updatingVisit,
  setActiveIndex,
  selected,
  setSelected,
  selectedMedications,
  setSelectedMedications,
}) {
  const { showAlert } = useToastify();
  const { setShowModal } = useModal();

  function onRightButtonClick(_, nextAnimation) {
    updateVisit({
      payload: {
        case: {
          id: incompleteData?.id,
          medications:
            selected === "None"
              ? []
              : selectedMedications?.map((el) => {
                  if (el?.DispensableDrugId) {
                    return {
                      name: el?.name,
                      DispensableDrugId: el?.DispensableDrugId,
                      RoutedDoseFormDrugId: el?.RoutedDoseFormDrugId,
                      NDC: el?.NDC,
                      RxCUI: el?.RxCUI || null,
                      Strength: el?.Strength || null,
                      IsObsolete: el?.IsObsolete,
                      dose: el?.dose,
                      frequency: el?.frequency,
                      per: el?.per,
                      form: el?.form,
                      other_form: el?.other_form,
                    };
                  }

                  return {
                    name: el?.name,
                    dose: el?.dose,
                    frequency: el?.frequency,
                    per: el?.per,
                    form: el?.form,
                    other_form: el?.other_form,
                  };
                }),
          bh_second_phase_steps: {
            ...incompleteData?.bh_second_phase_steps,
            [bh_sub_steps.medications]: "completed",
          },
        },
      },
      change_current_screen: false,
      screen_to_complete: null,
      callBack: () => {
        showAlert("Progress Saved Successfully", "success");
        setActiveIndex(9);
      },
    });
  }
  return (
    <div className="bg-white shadow-card rounded-b-4xl p-10 relative overflow-x-hidden">
      <Spacer height={20} />
      <RadioButtonCard
        loading={updatingVisit}
        options={["None"]}
        selected={selected}
        onSelect={(_) =>
          selected === "None" ? setSelected(null) : setSelected("None")
        }
      />
      <Spacer height={20} />
      <SearchInputWithChipCard
        inputLabel={"Search Medication"}
        onClickInput={() => {
          setSelected(null);
          setShowModal({
            state: true,
            children: (_, onClose) => {
              return (
                <AddMedicationModal
                  onClose={onClose}
                  selected={selectedMedications}
                  setSelected={setSelectedMedications}
                />
              );
            },
            data: null,
          });
        }}
        selected={selectedMedications}
        setSelected={setSelectedMedications}
      />
      <Button
        className="mt-10 py-4"
        disabled={selected === null && (!selectedMedications || selectedMedications.length === 0)}
        loading={updatingVisit}
        label="Next"
        onClick={onRightButtonClick}
      />
    </div>
  );
}

export default Medications;
